import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ClientService} from './client.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Secuence} from '../models/interface-secuence';
import {GlobalService} from '../services/global.service';

@Injectable({
    providedIn: 'root'
})

export class ModifyDataService {

    sequence: string;
    showLoader = false;
    email: string;
    adress: string;
    cp: string;
    population: string;
    province: string;
    phone: string;
    smscode: string;

    constructor(private http: HttpClient, private clientService: ClientService, private globalService: GlobalService) {
    }

    requestPassReset(documentNumber) {
        const body = {
            numDocumento: documentNumber
        };
        return this.http.post<Secuence>(`${this.globalService.urlApiParam}/api/forgotpassword/requestpasswordreset`, body);
    }

    checkResetCode(smsCode) {
        const body = {
            smscode: smsCode,
            sequence: sessionStorage.getItem('forgotpassword')
        };
        return this.http.post<Secuence>(`${this.globalService.urlApiParam}/api/forgotpassword/checkpasscode`, body);
    }

    setNewPassword(password) {
        const body = {
            password,
            sequence: sessionStorage.getItem('forgotpassword')
        };
        return this.http.post(`${this.globalService.urlApiParam}/api/forgotpassword/setnewpassword`, body);
    }

    changeDataClient() {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            direccion: this.adress,
            codigoPostal: this.cp,
            poblacion: this.population,
            provincia: this.province
        };
        return this.http.post(`${this.globalService.urlApiParam}/api/clientes/updatepersdata`, body, {headers});
    }

    changeFirstPassword(password) {
        const data = JSON.parse(sessionStorage.getItem('sequenceFirstPass'));
        const body = {
            email: data.email,
            password,
            sequence: data.sequence
        };
        return this.http.post(`${this.globalService.urlApiParam}/api/authenticate/changefirstpassword`, body);
    }

    requestChangeUserPhone() {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });

        const body = {
            phone: sessionStorage.getItem('modify_phone_data')
        };
        return this.http.post(`${this.globalService.urlApiParam}/api/clientes/requestchangephone`, body, {headers});
    }

    confirmChangeUserPhone(smscode) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });

        const body = {
            smscode,
            sequence: sessionStorage.getItem('sequence_modify_phone')
        };
        return this.http.post(`${this.globalService.urlApiParam}/api/clientes/verifyphoneandsave`, body, {headers});
    }
}
